// Direktiv som begränsar vad som går att skriva i ett fält.
//
//   v-digits         → bara siffror (mm-fälten: höjder, dimensioner, sandfång/stalp, vinkel)
//   v-digits:phone   → siffror, mellanslag och bindestreck, samt '+' först (+46 70-123 45 67)
//
// Filtreringen sker på 'input' istället för 'keydown' – då fångas även inklistring,
// drag-and-drop och autofyll, inte bara tangenttryck.

const rules = {
  digits: (value) => value.replace(/\D/g, ''),
  // '+' behålls bara som första tecken.
  phone: (value) => value.replace(/[^\d +-]/g, '').replace(/(?!^)\+/g, ''),
}

function sanitize(el, rule) {
  const clean = rule(el.value)
  if (clean === el.value) return

  const removed = el.value.length - clean.length
  const caret = el.selectionStart
  el.value = clean

  // Håll markören kvar där användaren skrev – utan detta hoppar den till slutet
  // så fort ett tecken filtreras bort mitt i en sträng.
  if (caret !== null) {
    const pos = Math.max(0, caret - removed)
    el.setSelectionRange(pos, pos)
  }

  // Låt v-model se det städade värdet. Andra rundan hittar inget att städa.
  el.dispatchEvent(new Event('input'))
}

export default {
  mounted(el, binding) {
    const rule = rules[binding.arg] || rules.digits
    // Direktivet kan sitta på en wrapper – ta fallet med en inre input också.
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (!input) return

    input._digitsHandler = () => sanitize(input, rule)
    input.addEventListener('input', input._digitsHandler)

    // Normalisera ev. förifyllt värde.
    sanitize(input, rule)
  },

  unmounted(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (input && input._digitsHandler) {
      input.removeEventListener('input', input._digitsHandler)
      delete input._digitsHandler
    }
  },
}
